// TODO: нормальные картинки с CDN будут в другой задаче
import calcImage from './images/calc.png';
import discountImage from './images/discount.png';
import houseImage from './images/house.png';
import ponyImage from './images/pony.png';

export interface ISeoLinkItem {
  title: string;
  href: string;
  imageSrc: string;
}

export const seoLinks: ISeoLinkItem[] = [
  {
    title: 'Ипотека на ваших условиях',
    href: '/ipoteka/calculator?banner=new-header-ipoteka-calc',
    imageSrc: calcImage,
  },
  {
    title: 'Господдержка для семей',
    href: '/ipoteka/s-gospodderzhkoj/',
    imageSrc: ponyImage,
  },
  {
    title: 'Ипотека на дома и строительство',
    href: '/ipoteka-suburban/',
    imageSrc: houseImage,
  },
  {
    title: 'Скидки на ипотеку от застройщиков',
    href: '/skidki-i-akcii/',
    imageSrc: discountImage,
  },
];
